import { HttpClient } from '@angular/common/http';
import { Directive, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PropertiesSettings } from '../../../core/configuration/properties-settings';
import { HelpersService } from '../../../core/services/helpers.service';
import { ModalNotifyService } from '../../../core/services/modal-notify.service';
import { OperationsService } from '../../../core/services/operations.service';
import { FileInputComponent } from '../../components/input-component/file-input/file-input.component';
import { DocumentoAllegato } from '../../models/documento-allegato';
import { DataInput } from '../../models/dto/data-input';
import { FileUploadResponse } from '../../models/dto/file-upload-response';
import { UpdateMetadatiDocumentoRequest } from '../../models/dto/update-metadati-documento-request';
import { FileData } from '../../models/file-data';
import { BaseForm } from '../base-Form';
import { environment } from 'src/environments/environment';
import { SsoStrategyService } from 'src/app/sso-strategy.service';
import { VisibilitaDocumento } from '../../models/tipologiche/visibilita-documento';
import { UploadDocumentUtilityService } from './document-uploaded/upload-document-utility.service';
import { MetadatoDocumento } from './document-uploaded/campi';
import { TipoTipologica } from '../../models/tipologiche/tipo-tipologica';
import { Observable, switchMap } from 'rxjs';
import { FileManagerService } from 'src/app/core/components/upload-tool/services/file-manager.service';
import { ServicePathsSettings } from 'src/app/core/configuration/service-paths-settings';

declare var closeModal: any;
declare var recuperaTokenCSRF;


@Directive()
export abstract class DocumentVersionUpdateFormAbstractComponent extends BaseForm implements OnInit {

  static ToolTipElement;
  updateDocVersionForm: FormGroup;
  fileData: FileData;
  file: File;
  documento: DocumentoAllegato;
  disableSubmit: boolean = true;
  fileUploaded: boolean = false;
  documentoAllegatoPerForm: DocumentoAllegato | null = null;
  private fileUploadedName: string;


  XSRF: string;
  modalNotifyService: ModalNotifyService;

  @Input() fascicolo;
  @Input() tipoPratica: string;
  @Output() onReturn = new EventEmitter();
  @ViewChild('updateTooltip') el: ElementRef;
  @ViewChild('fileInputComponent') fileInputComponent: FileInputComponent;
  tipiVisibilitaDocumento: VisibilitaDocumento[];
  abstract getUrlUploadNewVersionDocumento(): string;
  abstract getUrlUploadNewVersionDocumentoMissingFile(): string;
  abstract getRefDocumentale(): string;

  constructor(
    protected operationService: OperationsService, 
    private campiForm: FormBuilder, 
    private helpers: HelpersService, 
    private httpService: HttpClient, 
    private modalNotify: ModalNotifyService,
    private ssoStrategy: SsoStrategyService,
    public uploadUtilityService: UploadDocumentUtilityService,
    private fileManager: FileManagerService
  ) {
    super();
    this.modalNotifyService = modalNotify;
  }

  ngOnInit() {
    this.disableSubmit = true;
    this.documentoAllegatoPerForm = null;
    this.getTipiVisibilitaDocumento();
  } 

  ngOnChanges() {
    this.disableSubmit = true;
    this.documentoAllegatoPerForm = null;
  }

  createForm(documento: DocumentoAllegato) {
    this.documentoAllegatoPerForm = null;
    this.disableSubmit = true;
    if (DocumentVersionUpdateFormAbstractComponent.ToolTipElement) {
        DocumentVersionUpdateFormAbstractComponent.ToolTipElement.close();
    }
    if (this.fileInputComponent) {
      this.fileInputComponent.resetComponent();
    }
    this.documento = documento;
    this.fileUploaded = false;
    this.updateDocVersionForm = this.campiForm.group({
      note: [documento?.note ?? ''],
      tipoVisibilitaDocumento:[documento?.tipoVisibilitaDocumento ?? '',Validators.required],
      dataRiferimento: [documento?.dataRiferimento ?? null, Validators.required],
    });
  }

  deleteFileToDocumentaleCallback() {
    this.disableSubmit = true;
    this.documentoAllegatoPerForm = null;
  }

  onFileUploaded(file: any) {
    this.file = file;
    this.disableSubmit = false;
  }

  setFileDataRequest(fileData: FileData) {
    this.disableSubmit = false;
  }

  // refreshAfterUploadNewVersion(documento: DocumentoAllegato) {
  //   if ('primary' in documento) {
  //     delete (documento as any).primary;    
  //   }
  //   const formVal = this.updateDocVersionForm.value;
  //   documento.nomeFile = this.file?.name;
  //   documento.note = formVal?.note;
  //   documento.dataRiferimento = formVal?.dataRiferimento;
  //   let request: UpdateMetadatiDocumentoRequest = new UpdateMetadatiDocumentoRequest();
  //   request.documento = documento;
  //   request.dataInput = new DataInput(this.fascicolo.praticaBase.id, this.fascicolo.id, this.fascicolo.praticaBase.intestazione.campi.posizionePratica, this.fascicolo.posizione, this.fascicolo.praticaBase.tipoPratica.id);

  //   this.operationService.updateMetadatiDocumento(request).subscribe(response => this.onReturn.emit(response));
  //   this.disableSubmit = true;
  //   this.documentoAllegatoPerForm = null;
  // }

  uploadFile(file: File, isLastOne?): Observable < FileUploadResponse > {  
    return this.fileManager.getPayloadFile(file).pipe(
        switchMap((res) => this.getObsFileUploadResponse(res)));  
  }
  
  private getObsFileUploadResponse(payload: { fileData: {}; }): Observable<FileUploadResponse> {
    return this.httpService.post<FileUploadResponse>(this.getUrlUploadDocumento(), payload, { withCredentials: true, });
  }

  // uploadFileOnly(file: File): Promise<FileData> {
  //   return new Promise((resolve, reject) => {
  //     const xhr = new XMLHttpRequest();
  //     const isMissingFile = this.documento?.missingFile;
  //     const uploadUrl = isMissingFile
  //       ? this.getUrlUploadNewVersionDocumentoMissingFile()
  //       : this.getUrlUploadNewVersionDocumento();

  //     xhr.open('POST', uploadUrl, true);

  //     const formData = new FormData();
  //     if (isMissingFile) {
  //       formData.append('idDocumento', this.documento.id);
  //       formData.append('idFascicolo', this.fascicolo.id);
  //     } else {
  //       formData.append('refDocumentale', this.getRefDocumentale());
  //     }
  //     formData.append('contenuto', file);
  //     formData.append('nomeFile', file.name);

  //     xhr.withCredentials = true;
  //     xhr.setRequestHeader('X-XSRF-TOKEN', this.getXSRFToken()['XSRF-TOKEN']);

  //     // header aggiuntivi per OAuth2 / TLF
  //     if (this.ssoStrategy.getAuthMode() === "oauth2") {
  //       xhr.setRequestHeader('Authorization', `Bearer ${localStorage.getItem('access_token')}`);
  //     }
  //     const smUser = localStorage.getItem('TLF_USER');
  //     const smTenant = localStorage.getItem('TLF_TENANT') || '';
  //     if (smUser) {
  //       xhr.setRequestHeader('TLF_USER', smUser);
  //       xhr.setRequestHeader('TLF_PRODUCT', 'teleforum');
  //       xhr.setRequestHeader('TLF_TENANT', smTenant);
  //     }

  //     xhr.onreadystatechange = () => {
  //       if (xhr.readyState === 4) {
  //         if (xhr.status === 200) {
  //           const response: FileUploadResponse = JSON.parse(xhr.response);
  //           resolve(response.fileData);
  //         } else {
  //           reject(xhr.response);
  //         }
  //       }
  //     };

  //     xhr.send(formData);
  //   });
  // }

  onDocReturn(event: any) {
    if (!event || !event.refDocumentale) return;
      const nuovoMetadato: MetadatoDocumento = {
        modalitaFormazioneDocumento: this.mapToTipoTipologica(event.modalitaFormazioneDocumento),
        motivoAssenzaFirma: this.mapToTipoTipologica(event.motivoAssenzaFirma),
        documentoUnico: event.documentoUnico,
        tipoUfficioProduttore: this.mapToTipoTipologica(
          event.tipoUfficioProduttore ?? 'ESTERNO'
        ),
        ufficioProduttore: event.ufficioProduttore,
        numDocumentiScansione: event.numDocumentiScansione,
        documentiScansionati: event.documentiScansionati
      };
    if (this.documentoAllegatoPerForm) {
      this.documentoAllegatoPerForm.metadatoDocumento = nuovoMetadato;
    }
  }
  saveDocumentMetadata() {
    if (!this.documentoAllegatoPerForm) return;
    const formVal = this.updateDocVersionForm.value;
    this.documento.nomeFile = this.documentoAllegatoPerForm.nomeFile;
    this.documento.note = formVal.note;
    this.documento.dataRiferimento = formVal.dataRiferimento;
    this.documento.metadatoDocumento = this.documentoAllegatoPerForm.metadatoDocumento;
    this.documento.refDocumentale = this.documentoAllegatoPerForm.refDocumentale;
    this.documento.contentType = this.documentoAllegatoPerForm.contentType;
    this.documento.contentSize = this.documentoAllegatoPerForm.contentSize;
    const request: UpdateMetadatiDocumentoRequest = new UpdateMetadatiDocumentoRequest();
    request.documento = this.documento;
    request.dataInput = new DataInput(
      this.fascicolo.praticaBase.id,
      this.fascicolo.id,
      this.fascicolo.praticaBase.intestazione.campi.posizionePratica,
      this.fascicolo.posizione,
      this.fascicolo.praticaBase.tipoPratica.id
    );

    this.operationService.updateMetadatiDocumentoNewVersion(request)
      .subscribe(response => this.onReturn.emit(response));

    this.disableSubmit = true;
  }

  mapToTipoTipologica = (key?: string): TipoTipologica | undefined => {
    if (!key) return undefined;
    return { id: key, descrizione: '', label: '', rimosso: false };
  };

  uploadNewVersionFailed() {
    DocumentVersionUpdateFormAbstractComponent.ToolTipElement.ngbTooltip = PropertiesSettings.UPDATE_FILE_UPLOAD_ERROR;
    DocumentVersionUpdateFormAbstractComponent.ToolTipElement.open();
  }

  transferFailed(evt) {
    DocumentVersionUpdateFormAbstractComponent.ToolTipElement.ngbTooltip = PropertiesSettings.TRANSFER_UPLOAD_ERROR;
    DocumentVersionUpdateFormAbstractComponent.ToolTipElement.open();
  }

  transferCanceled(evt) {
    DocumentVersionUpdateFormAbstractComponent.ToolTipElement.ngbTooltip = PropertiesSettings.CANCEL_UPLOAD_ERROR;
    DocumentVersionUpdateFormAbstractComponent.ToolTipElement.open();
  }


  getXSRFToken = () =>
  document.cookie.split('; ').reduce((acc, value) => {
    const cookie = value.split('=');
    acc[cookie[0]] = cookie[1];
    return acc;
  }, {});

  getTipiVisibilitaDocumento(){
    this.helpers.getTipiVisibilitaDocumento().subscribe(response => this.tipiVisibilitaDocumento = response);
  }

  deleteFile(event?: any) {
    this.documentoAllegatoPerForm = null;
    this.file = null;
    this.disableSubmit = true;

    if (this.fileInputComponent) {
      this.fileInputComponent.resetComponent();
    }
  }

  onFileSelected(event: any) {
    if (!event || !event.length) return;
    const file: File = event[0]; 
    this.disableSubmit = true;

    this.uploadFile(file)
      .subscribe(res => {
        if (res && res.fileData) {
          this.documentoAllegatoPerForm = {
            refDocumentale: res.fileData.refDocumentale,
            nomeFile: res.fileData.nomeFile,
            contentType: res.fileData.contentType,
            contentSize: res.fileData.contentSize,
            signedData: res.fileData.signedData,
          } as DocumentoAllegato;

          this.setFileDataRequest(res.fileData);
          this.fileUploaded = true;
          this.fileUploadedName = res.fileData.nomeFile;
          this.disableSubmit = false;
        }
      });
  }

  getUrlUploadDocumento() {
    return ServicePathsSettings.DOMINIO + ServicePathsSettings.URL_UPLOAD_DOCUMENTO;
  }

}
